<template>
	<div class="main-containter" id="top" v-title data-title="北京和合网链科技有限公司">
		<PHeader :checkId="'联系我们'"  :activeNames="'联系我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">联系我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Contact Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 联系我们</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:center;width:94%;">联系我们</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;text-align:center;width:94%;">Contact Us</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:center;width:94%;margin-bottom: 30px;">
				<div style="height: 365px;margin-top: 20px;text-align: left;" v-for="(item,index) in list" :key="index">
					<div style="height: 200px;width: 100%;">
						<img style="width: 100%;height: 100%;" :src="item.img">
					</div>
					<div style="height: 30px;line-height: 35px;">
						<span style="font-size: 18px;font-weight: 600;color: #98273A;">{{item.name}}</span>
						<span style="font-size: 12px;"> /{{item.ename}}</span>
					</div>
					<div style="margin-top: 10px;margin-bottom: 5px;width: 30px;height: 2px;background-color: #98273A;"></div>
					<div style="border-top: 1px solid #DFDFDF;padding-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/地址.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.address}}</span>
					</div>
					<div style="margin-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/邮箱3.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.email}}</span>
					</div>
					<div style="margin-top: 15px;min-height: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;float: left;" src="../../assets/fImage/电话.png">
						<span style="color: rgb(89, 89, 89);font-size: 14px;display: block;float: left;width: calc(100% - 35px);margin-left: 15px;">{{item.phone}}</span>
					</div>
					<!-- <div style="margin-top: 20px;">
						<img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/电话.png">
						<span style="margin-left: 15px;color: #595959;font-size: 14px;">{{item.fax}}</span>
					</div> -->
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {create,query} from "@/api/leaveMassage";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				list:[

				],
				name:'',
				email:'',
				phone:'',
				area:'',
				desc:''
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			submit(){
				if(!this.name){
					this.$message.error('请输入您的姓名')
				}else if(!this.phone){
					this.$message.error('请输入您的联系方式')
				}else if(!this.email){
					this.$message.error('请输入您的电子邮箱')
				}else if(!this.city){
					this.$message.error('请输入您的所在城市')
				}else if(!this.content){
					this.$message.error('请详细描述您请求的内容')
				}else{
					let param = {}
					param.name = this.name;
					param.phone = this.phone;
					param.email = this.email;
					param.city = this.area;
					param.content = this.desc;
					create(param).then(data => {
						this.$message.success("提交成功!")
						this.name = ''
						this.phone = ''
						this.email = ''
						this.area = ''
						this.desc = ''
					}).catch(error => {
						this.$message.error(error)
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
